export default __webpack_public_path__ + "static/media/hht2_sitcom_20.1e953b69.png";